<template>
  <!-- 修改后的消息弹窗 -->
  <el-dialog
      title="消息通知"
      :visible.sync="messageDialogVisible"
      custom-class="centerMessage"
      style="margin-top: 10vh"
  >
    <div class="message-container">
      <div
          v-for="(message, index) in allMessages"
          :key="message.id"
          class="message-item unread"
          @click="viewMessage(message)"
      >
        <div class="message-header">
          <span class="message-title">{{ truncateTitle(message.title) }}</span>
          <el-tag
              v-if="message.readstatus == 0"
              size="mini"
              type="danger"
              class="unread-tag"
          >未读</el-tag>
          <span class="message-time">{{ message.gmtCreated }}</span>
        </div>
        <div class="message-content">{{ truncateContent(message.content) }}</div>
        <el-divider v-if="index < allMessages.length - 1" />
      </div>

      <div v-if="allMessages.length === 0" class="empty-message">
        暂无消息
      </div>
    </div>

    <div class="pagination-container">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10]"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total"
      />
    </div>
  </el-dialog>
</template>

<script>
import { getUserMessage,updateUserMessage} from "@/API/home/home";
import DC from "@/util/SocketHandler";
export default {
  name: "messageCenter",
  data() {
    return {
      messageDialogVisible: this.visible,
      allMessages: [],
      currentPage: 1,
      pageSize: 10,
      total:0,
      unreadCount:0,
      messageHandler: null // 存储处理器
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    visible(newVal) {
      this.messageDialogVisible = newVal
      if(newVal) {
        this.getMessageList()
      }
    },
    messageDialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  mounted() {
   this.registerMessage()
  },
  methods: {
    registerMessage() {
      // 保存处理器引用
      this.messageHandler = (data) => {
        this.getMessageList();
      };
      DC.registerMessageHandler('MESSAGE', 'messageNotify', this.messageHandler);
    },
    unregisterMessage() {
      if (this.messageHandler) {
        DC.unregisterMessageHandler('MESSAGE', 'messageNotify', this.messageHandler);
        this.messageHandler = null; // 清理引用
      }
    },
    getMessageList(){
      let parmrs = {
        pageNum:this.currentPage,
        pageSize:this.pageSize
      }
      getUserMessage(parmrs).then(res=>{
        if(res.code === 200) {
          this.allMessages = res.data?.records || []
          this.unreadCount = res.data.unreadNum
          this.total = res.data.total
        }
      })
    },
    truncateTitle(title) {
      return title.length > 15 ? title.substring(0, 15) + '...' : title;
    },
    truncateContent(content) {
      return content.length > 30 ? content.substring(0, 30) + '...' : content;
    },
    formatTime(time) {
      return new Date(time).toLocaleString();
    },
    viewMessage(message) {
      message.read = true;
      // 关闭所有通知
      this.$notify.closeAll();
      // 弹出新通知
      this.$notify.warning({
        title: message.title,
        message: message.content,
        customClass: "top-center-notify", // 关键：自定义 class
        duration: 5000,
      });
      if(message.readstatus === 0) {
        updateUserMessage(message.id).then(res=>{
          if(res.code === 200) {
           this.$emit('updateMsgStatus',true)
            message.readstatus = 1
          }
        })
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getMessageList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMessageList()
    },
    handleClose(done) {
      this.$confirm('确定关闭消息窗口吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        done()
      }).catch(() => {})
    },
  },
  destroyed() {
    this.unregisterMessage()
  }
}
</script>

<style scoped lang="less">
/deep/.centerMessage {
  width:500px;
}
.message-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 10px;

  .message-item {
    padding: 12px 0;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #f5f7fa;
    }

    &.unread {
      .message-title {
        font-weight: bold;
        color: #303133;
      }
    }

    .message-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;

      .message-title {
        flex: 1;
        font-size: 14px;
        color: #606266;
      }

      .unread-tag {
        margin: 0 10px;
      }

      .message-time {
        font-size: 12px;
        color: #909399;
      }
    }

    .message-content {
      font-size: 13px;
      color: #909399;
      line-height: 1.5;
    }
  }

  .empty-message {
    text-align: center;
    padding: 40px 0;
    color: #909399;
    font-size: 14px;
  }
}

.pagination-container {
  margin-top: 20px;
  text-align: center;
}

.el-divider {
  margin: 12px 0;
}
/* 强制让通知框居中 */
.top-center-notify {
  left: 50% !important;
  transform: translateX(-50%) !important;
  top: 85px !important; /* 调整距离顶部的位置 */
}
@media screen and (max-width: 768px) {
  /deep/.centerMessage {
    width:90% !important;
  }
}
</style>
